export const enum OnboardingSequenceEnum {
  PLAYER = 'player',
  SKILL_DETAIL = 'skillDetail',
}
